export { default, getServerSideProps } from './[...slug]';
